import {React} from 'common'
import Menu from '@mui/material/Menu'
import MainMenuItem from './MainMenuItem'
import {styled} from '@mui/material'
import {Colors, Styles} from 'appearance'
import UseMainMenu from 'logic/Menu/UseMainMenu'

const MainMenu = ({menuId, anchorEl, setAnchorEl, setMobileMoreAnchorEl}) => {
    const {
        isMenuOpen,
        handleProfile,
        handleMenuClose,
        handleLogoutClick,
        t,
        user,
        goToLogin,
    } = UseMainMenu({anchorEl, setAnchorEl, setMobileMoreAnchorEl})

    return (
        <AccountMenu
            anchorEl={anchorEl}
            className="menu"
            anchorOrigin={Styles.MENU_ANCHOR_ORIGIN}
            id={menuId}
            keepMounted
            open={isMenuOpen}
            onClose={handleMenuClose}>
            {user ? (
                [
                    <MainMenuItem
                        key="myAccount"
                        onClick={handleProfile}
                        type="myAccount"
                        text={t('myAccount')}
                    />,
                    <MainMenuItem
                        key="logout"
                        onClick={handleLogoutClick}
                        type="logout"
                        text={t('logout')}
                    />,
                ]
            ) : (
                <MainMenuItem
                    key="login"
                    onClick={goToLogin}
                    type="login"
                    text={t('login')}
                />
            )}
        </AccountMenu>
    )
}

export default MainMenu

export const AccountMenu = styled(Menu)(() => ({
    '& .MuiPaper-root': {
        backgroundColor: Colors.APP_GRAY_LIGHT,
    },
}))
